import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { useTranslate, useLocale, useSetLocale, Title } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { changeTheme } from './actions';
import { AppState } from '../types';

const useStyles = makeStyles({
    label: { width: '10em', display: 'inline-block' },
    button: { margin: '1em' },
});

const SetLocaleStorage = (setLocale: any, locale: any) => {
    setLocale(locale);
    localStorage.setItem('language', locale);
}

const Configuration = () => {
    const translate = useTranslate();
    const locale = useLocale();
    const classes = useStyles();
    const theme = useSelector((state: AppState) => state.theme);
    const setLocale = useSetLocale();
    const dispatch = useDispatch();
    return (
        <Card>
            <Title title={translate('pos.configuration')} />
            <CardContent>
                <div className={classes.label}>
                    {translate('pos.theme.name')}
                </div>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={theme === 'light' ? 'primary' : 'default'}
                    onClick={() => dispatch(changeTheme('light'))}
                >
                    {translate('pos.theme.light')}
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={theme === 'dark' ? 'primary' : 'default'}
                    onClick={() => dispatch(changeTheme('dark'))}
                >
                    {translate('pos.theme.dark')}
                </Button>
            </CardContent>
            <CardContent>
                <div className={classes.label}>{translate('pos.language')}</div>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'cz' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale,'cz')}
                >
                    cz
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'de' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'de')}
                >
                    de
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'en' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'en')}
                >
                    en
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'hr' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'hr')}
                >
                    hr
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'hu' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'hu')}
                >
                    hu
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'pl' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'pl')}
                >
                    pl
                </Button>
                <Button
                    variant="contained"
                    className={classes.button}
                    color={locale === 'ro' ? 'primary' : 'default'}
                    onClick={() => SetLocaleStorage(setLocale, 'ro')}
                >
                    ro
                </Button>
            </CardContent>
        </Card>
    );
};

export default Configuration;
